module.exports = __webpack_public_path__ + "img/wenwubaopi_icon@2x.6d97fc82.png";